module.exports = __webpack_public_path__ + "img/twitter-logo.923455be.svg";